import { COLUMN_FORMAT, TOTALS_FIELD } from "../constants";

/**
 * The bottom Totals panel, as a dynamic-form layout.
 *
 * A form, not a grid: the Delphi renders six read-only currency edits across three group boxes
 * (uFMD0000.dfm <c>grpTotalsLeft</c> / <c>grpTotalsMiddle</c> / <c>GrpTotalsRight</c>), and the group
 * captions and field order below follow that form.
 *
 * Every field is `readOnly` and `required: false`. These are computed sums, not input: there is nothing
 * to validate and nothing to save - the whole board is read-only.
 *
 * `isLabelChanged: true` throughout so Fields.js uses the literal label rather than a localization
 * lookup - these captions come from the Delphi form and no localization keys exist for them.
 */
// The Delphi renders the four quantity edits with DisplayFormat "#.##" and the two revenue edits
// with "$,0.00;$,0.00-" (uFMD0000.dfm edtTotalItems/Weight/Cubes/Pallets, edtFreghtRev/edtMercRev),
// so the quantities carry two decimals here too - including Items and Pallets, which the desktop
// also shows to two places even though the columns they sum are whole units. Same objects the grid
// columns use, so a total is formatted like the column it came from.
const { DEC, MONEY } = COLUMN_FORMAT;

const TotalsLayout = [
    {
        groupId: 1,
        label: "Quantities",
        fields: [
            {
                name: TOTALS_FIELD.Items,
                format: DEC.format,
                label: "Items",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: TOTALS_FIELD.Weight,
                format: DEC.format,
                label: "Weight",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 2,
        label: "Volume",
        fields: [
            {
                name: TOTALS_FIELD.Cubes,
                format: DEC.format,
                label: "Cubes",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: TOTALS_FIELD.Pallets,
                format: DEC.format,
                label: "Pallets",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 3,
        label: "Revenue",
        fields: [
            {
                name: TOTALS_FIELD.FreightRevenue,
                format: MONEY.format,
                label: "Freight Rev",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: TOTALS_FIELD.MerchandiseRevenue,
                format: MONEY.format,
                label: "Merch Rev",
                type: "number",
                readOnly: true,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { TotalsLayout };
